import { ContactSegment } from '../types/segments.types';

export const ORDERED_SEGMENTS: string[] = [
  ContactSegment.HIGH_POTENTIAL_RETAILERS,
  ContactSegment.NEED_RESTOCK,
  ContactSegment.DISENGAGED_OR_SEASONAL,
  ContactSegment.PROSPECTS,
  ContactSegment.ABANDONED_CART,
];
